const supportedTabs = {
  SUBSCRIPTIONS: 'subscriptions',
  BILLING_HISTORY: 'billing-history',
  PAYMENT_METHODS: 'payment-methods',
};

export default supportedTabs;
